<template>
  <vx-card :title="id === null ? 'Cadastrar Colaborador' : 'Editar Colaborador'">

    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <NaturalEntity
          v-if="employee !== null && employee.natural_entity !== null"
          :services="services"
          :naturalEntity="employee ? employee.natural_entity : null"
          :isEmployee="true"
          :employee="employee"
          :key="id"
        />

        <NaturalEntity
          v-else
          :isEmployee="true"
          :services="services"
        />
      </vs-tab>
      <vs-tab label="Jornada Trabalho" :disabled="isTabEnabled">
        <WorkingTime :services="services"/>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import vSelect from 'vue-select'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import PeopleService from '@/services/api/PeopleService'
import NaturalEntityService from '@/services/api/NaturalEntityService'
import LegalEntityService from '@/services/api/LegalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'
import OccupationService from '@/services/api/OccupationService'
import PronounTreatmentService from '@/services/api/PronounTreatmentService'
import PositionService from '@/services/api/PositionService'
import EmployeeService from '@/services/api/EmployeeService'
import WorkingTimeService from '@/services/api/WorkingTimeService'

import NaturalEntity from '../tabs/NaturalEntity'
import WorkingTime from '../tabs/WorkingTime.vue'

export default {
  components: {
    Datepicker,
    vSelect,
    NaturalEntity,
    WorkingTime
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    federationUnitList: [],
    emailTypeList: [],
    addressTypeList: [],
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      naturalEntityService: null,
      legalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      occupationService: null,
      pronounTreatmentService: null,
      positionService: null,
      employeeService: null,
      workingTimeService: null
    },
    employee: null
  }),
  methods: {
    save() {
      if (this.tabIndex === 0) {
        this.saveNaturalEntity()
      }
    }
  },
  computed: {
    isTabEnabled() {
      return this.id === null
    }
  },
  mounted() {},
  beforeMount() {
    this.$vs.loading()

    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.naturalEntityService = NaturalEntityService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(
      this.$vs
    )
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.occupationService = OccupationService.build(this.$vs)
    this.services.pronounTreatmentService = PronounTreatmentService.build(this.$vs)
    this.services.positionService = PositionService.build(this.$vs)
    this.services.employeeService = EmployeeService.build(this.$vs)
    this.services.workingTimeService = WorkingTimeService.build(this.$vs)

    this.services.emailTypeService.all().then(data => {
      this.emailTypeList = data
    })

    this.services.addressTypeService.all().then(
      data => {
        this.addressTypeList = data
        this.$vs.loading.close()
      },
      error => {
        this.$vs.loading.close()
      }
    )

    if (this.id) {
      this.services.employeeService.read(this.id).then(
        employee => {
          this.employee = employee
        }
      )
    }
  }
}
</script>